var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsOfServiceInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.5C4.70156 0.5 0 5.20156 0 11C0 16.7984 4.70156 21.5 10.5 21.5C16.2984 21.5 21 16.7984 21 11C21 5.20156 16.2984 0.5 10.5 0.5ZM10.5 19.7188C5.68594 19.7188 1.78125 15.8141 1.78125 11C1.78125 6.18594 5.68594 2.28125 10.5 2.28125C15.3141 2.28125 19.2188 6.18594 19.2188 11C19.2188 15.8141 15.3141 19.7188 10.5 19.7188Z",
    fill: "#FAAD14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37463 15.125C9.37463 15.4234 9.49316 15.7095 9.70414 15.9205C9.91512 16.1315 10.2013 16.25 10.4996 16.25C10.798 16.25 11.0842 16.1315 11.2951 15.9205C11.5061 15.7095 11.6246 15.4234 11.6246 15.125C11.6246 14.8266 11.5061 14.5405 11.2951 14.3295C11.0842 14.1185 10.798 14 10.4996 14C10.2013 14 9.91512 14.1185 9.70414 14.3295C9.49316 14.5405 9.37463 14.8266 9.37463 15.125ZM9.93713 12.5H11.0621C11.1653 12.5 11.2496 12.4156 11.2496 12.3125V5.9375C11.2496 5.83438 11.1653 5.75 11.0621 5.75H9.93713C9.83401 5.75 9.74963 5.83438 9.74963 5.9375V12.3125C9.74963 12.4156 9.83401 12.5 9.93713 12.5Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfServiceInfo);
export default __webpack_public_path__ + "static/media/terms-of-service-info.2f35640111b6339f92855f2dbb2a792d.svg";
export { ForwardRef as ReactComponent };